var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRingtoneDevice = function SvgRingtoneDevice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.98 18.61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#698db0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.23,12.69v-5s0-.07,0-0.11a5.75,5.75,0,0,0-11.51,0s0,0.07,0,.11v5c0,0.94-.77,1.37-1.49,1.85a5.61,5.61,0,0,0-.6.44l-0.21.2A1.52,1.52,0,0,0,0,16.25c0,1.8,4.26,2.36,8.48,2.36h0C12.7,18.61,17,18,17,16.25S14.23,14.45,14.23,12.69ZM7.45,3.2a4.33,4.33,0,0,1,2.05,0,4.44,4.44,0,0,1,3.43,4.37v5.11a2.67,2.67,0,0,0,.47,1.54,34.07,34.07,0,0,0-4.91-.37,34,34,0,0,0-4.92.37A2.67,2.67,0,0,0,4,12.69V7.54H4A4.43,4.43,0,0,1,7.45,3.2Zm1,14.11c-5,0-6.83-.78-7.16-1.12,0.72-.42,3.14-1,7.17-1s6.44,0.61,7.17,1C15.33,16.52,13.5,17.31,8.48,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0.71,8.23a0.65,0.65,0,0,0,.65-0.65A7.09,7.09,0,0,1,5.25,1.23,0.65,0.65,0,1,0,4.66.07a8.39,8.39,0,0,0-4.6,7.5A0.65,0.65,0,0,0,.71,8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.79,1.23a7.09,7.09,0,0,1,3.89,6.35,0.65,0.65,0,0,0,1.3,0,8.39,8.39,0,0,0-4.6-7.5A0.65,0.65,0,1,0,11.79,1.23Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRingtoneDevice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ringtone-device.79ffaac7.svg";
export { ForwardRef as ReactComponent };